import { Reducer } from 'redux';

export type Language = 'nb' | 'en'
const LANGUAGE_KEY = 'hoopla-language';

export const messages = {
  nb: require('../translations/nb.json'),
  en: require('../translations/en.json'),
}

const getLanguage = (): Language => {
  return localStorage.getItem(LANGUAGE_KEY) as Language || 'nb';
}

export const setLanguage = (language: Language) => {
  localStorage.setItem(LANGUAGE_KEY, language);

  return {
    type: 'CHANGE_LANGUAGE',
    language,
  }
}

export interface I18nState {
  locale: Language,
  messages: { [key: string]: string }
}

const initialState: I18nState = {
  locale: getLanguage(),
  messages: messages[getLanguage()],
};

const reducer: Reducer<I18nState> = (state = initialState, action): I18nState => {
  switch(action.type) {
    case 'CHANGE_LANGUAGE':
      return { locale: action.language, messages: messages[action.language as Language] };
    default:
      return state;
  }
}

export default reducer;
